import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../../api/api";
import { SwitchReservationPayloadType } from "../../schema/SwitchReservationSchema";
import { toast } from "sonner";

const API_VERSION = "v4";

const useSwitchReservation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: SwitchReservationPayloadType) => {
            const response = await privateApi.post(`/${API_VERSION}/booking/switch-reservation`, payload);
            return response.data;
        },
        onSuccess: async () => {
            // Invalidate calendar data
            await queryClient.invalidateQueries({ queryKey: ['bookings'] });
            toast.success("Reservation switched successfully");
        },
        onError: (error: any) => {
            const message = error.response?.data?.message || "Failed to switch reservation";
            toast.error(message);
        }
    });
};

export default useSwitchReservation;
